<template>
	<div class="tabs">
		<div :class="'tabs__tab' + (tab.name == active ? ' active' : '')" v-for="(tab, idx) in tabs" v-bind:key="idx" @click="$emit('input', name, tab.name)">{{ tab.label }}</div>
	</div>
</template>

<script>
	export default {
		props: {
			name: String,
			tabs: Array,
			active: String
		}
	}	
</script>

<style lang="scss">
	.tabs {
		color: white;
		height: 40px;

		&__tab {
			line-height: 40px;
			cursor: pointer;
			height: 40px;
			float: left;
			margin-left: 20px;
			font-size: 12px;

			&.active {
				border-bottom: 2px solid #f7223f;
			}
		}
	}

	.tabs.-side-window {
		width: 100%;
		//background-color: yellow;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(10px, 1fr));
		border: 1px solid #2d2f36;
		border-radius: 20px;
		overflow: hidden;

		& > .tabs__tab {
			line-height: 40px;
			cursor: pointer;
			height: 40px;
			margin: 0;
			font-size: 12px;
			text-align: center;
			float: none;
			border-right: red;
			color: #555963;

			&.active {
				border-bottom: none;
				background-color: #2d2f36;
				color: white;
			}
		}

		& > .tabs__tab:last-child {
			border-right: none;
		}
	}
</style>